import { z } from 'zod';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { InvitePage } from '@/components/invite-page';
import { invitePageSchema } from '@/components/schemas';
import { InvitationAction, InvitationType } from '@/components/types';

const InviteRoute = () => {
  const search = useSearch({ from: '/invitations' });
  const { id, email, type, action } = search as z.infer<typeof invitePageSchema>;

  return (
    <InvitePage
      action={action as InvitationAction}
      email={email}
      id={id}
      type={type as InvitationType}
    />
  );
};

export const Route = createFileRoute('/invitations/')({
  component: InviteRoute,
  validateSearch: zodValidator(invitePageSchema),
});
